import React from 'react';
import PropTypes from 'prop-types';
import GenericDndDropZone from './GenericDndDropZone';
import './index.scss';

const GenericDndContainer = ({
  items,
  itemType,
  renderItem,
  onMove,
  classNames,
}) => {
  const containerClass = classNames?.container || '';
  const wrapperClass = classNames?.itemWrapper || '';
  const dropZoneClass = classNames?.dropZone || '';

  return (
    <div className={`generic-dnd-container ${containerClass}`}>
      <GenericDndDropZone
        index={0}
        onMove={onMove}
        itemType={itemType}
        className={dropZoneClass}
      />

      {items.map((item, index) => (
        <React.Fragment key={item.id}>
          <div className={wrapperClass}>{renderItem({ item, index })}</div>
          <GenericDndDropZone
            index={index + 1}
            onMove={onMove}
            itemType={itemType}
            className={dropZoneClass}
          />
        </React.Fragment>
      ))}
    </div>
  );
};

GenericDndContainer.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  itemType: PropTypes.string.isRequired,
  renderItem: PropTypes.func.isRequired,
  onMove: PropTypes.func.isRequired,
  classNames: PropTypes.shape({
    container: PropTypes.string,
    itemWrapper: PropTypes.string,
    dropZone: PropTypes.string,
  }),
};

export default GenericDndContainer;
